/**
 * Frontend-only Wishlist Engine
 * Using Liquid + Vanilla JavaScript
 */

window.Wishlist = (function() {
  // private state
  let items = [];
  const STORAGE_KEY = 'wishlist';
  let debounceTimer;

  /**
   * Save wishlist to localStorage with debounce
   */
  function saveToStorage() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ items }));
      } catch (e) {
        console.error('Wishlist storage error:', e);
      }
    }, 150);
  }

  /**
   * Update all wishlist buttons on the page
   */
  function syncWishlistUI() {
    const buttons = document.querySelectorAll('.wishlist-btn');
    buttons.forEach(btn => {
      const variantId = btn.dataset.variantId;
      if (hasItem(variantId)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Update global count if element exists
    const countEl = document.getElementById('wishlist-count');
    if (countEl) {
      const bubble = countEl.closest('.wishlist-count-bubble');
      const count = getCount();
      countEl.textContent = count;
      if (bubble) {
        bubble.style.display = count > 0 ? 'flex' : 'none';
      }
    }

  }

  /**
   * Check if item exists in wishlist
   */
  function hasItem(variantId) {
    if (!variantId) return false;
    return items.some(item => String(item.variant_id) === String(variantId));
  }

  /**
   * Get total count
   */
  function getCount() {
    return items.length;
  }

  /**
   * Initialize wishlist from localStorage
   */
  function init() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsed = JSON.parse(stored);
        items = Array.isArray(parsed.items) ? parsed.items : [];
      }
    } catch (e) {
      console.warn('Wishlist initialization failed, starting fresh.');
      items = [];
    }
    
    // Mark buttons on load
    syncWishlistUI();

    // Event delegation for clicks
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.wishlist-btn');
      if (!btn) return;

      e.preventDefault();
      const productId = btn.dataset.productId;
      const variantId = btn.dataset.variantId;

      if (!productId || !variantId) {
        console.warn('Wishlist: Missing product or variant ID on button.');
        return;
      }

      toggleItem(productId, variantId);
    });

    // Listen for custom event to re-sync (useful after dynamic content loads)
    document.addEventListener('wishlist:sync', syncWishlistUI);
  }

  /**
   * Add item to wishlist
   */
  function addItem(productId, variantId) {
    if (!variantId || hasItem(variantId)) return;
    
    items.push({
      product_id: productId,
      variant_id: variantId,
      added_at: Math.floor(Date.now() / 1000)
    });

    saveToStorage();
    syncWishlistUI();
  }

  /**
   * Remove item from wishlist
   */
  function removeItem(variantId) {
    if (!variantId) return;
    
    items = items.filter(item => String(item.variant_id) !== String(variantId));

    saveToStorage();
    syncWishlistUI();
  }

  /**
   * Toggle item in wishlist
   */
  function toggleItem(productId, variantId) {
    if (hasItem(variantId)) {
      removeItem(variantId);
    } else {
      addItem(productId, variantId);
    }
  }

  return {
    init,
    getItems: () => [...items],
    addItem,
    removeItem,
    hasItem,
    toggleItem,
    getCount,
    syncUI: syncWishlistUI
  };
})();

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  window.Wishlist.init();
});
